export default {
    state: {
        list: null,
        count: null,
        filters: {
            search: '',
            orderBy: 'descricao',
            desc: false,
        },
    },

    mutations: {
        TAG_SET_LIST(state, list) {
            state.list = list
        },

        TAG_SET_COUNT(state, count) {
            state.count = count
        },

        TAG_SET_FILTER(state, {key, value}) {
            state.filters = {
                ...state.filters,
                [key]: value,
            }
        },
        SET_TAG_LIST(state, list) {
            state.list = list
        },

        TAG_RESET_FILTERS(state){
            state.filters = {
                search: '',
                orderBy: 'descricao',
                desc: false,
            }
        },

    },
}
